export interface NoticeInfoDTO {
    boardCategory: string,
    boardInfoSeq: number,
    title: string,
    contents: string,
    fileInfo?:object
}

export const createNoticeInfoDTO : NoticeInfoDTO = {
    boardCategory: "BOARD",
    boardInfoSeq: null,
    title: '',
    contents: ''
}

export interface FaqInfoDTO {
    boardCategory: string,
    seq: number,
    title: string,
    contents: string;
}

export const createFaqInfoDTO : FaqInfoDTO = {
    boardCategory: "FAQ",
    seq: null,
    title: '',
    contents: ''
}